(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('practice-profile', {
            parent: 'entity',
            url: '/practice-profile?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practiceProfile.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice-profile/practice-profiles.html',
                    controller: 'PracticeProfileController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practiceProfile');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('practice-profile-detail', {
            parent: 'practice-profile',
            url: '/practice-profile/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'getwellApp.practiceProfile.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/practice-profile/practice-profile-detail.html',
                    controller: 'PracticeProfileDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('practiceProfile');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PracticeProfile', function($stateParams, PracticeProfile) {
                    return PracticeProfile.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'practice-profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('practice-profile-detail.edit', {
            parent: 'practice-profile-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice-profile.new', {
            parent: 'practice-profile',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                location_directions: null,
                                images: null,
                                description: null,
                                welcome_message: null,
                                slogan: null,
                                taxpunktwert: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('practice-profile');
                });
            }]
        })
        .state('practice-profile.edit', {
            parent: 'practice-profile',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-dialog.html',
                    controller: 'PracticeProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('practice-profile.delete', {
            parent: 'practice-profile',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/practice-profile/practice-profile-delete-dialog.html',
                    controller: 'PracticeProfileDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PracticeProfile', function(PracticeProfile) {
                            return PracticeProfile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('practice-profile', null, { reload: 'practice-profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
